import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import BasicTable from "../../components/Table/BasicTable.jsx";
import {
  StorecanlenderFilter,
  StoreColumns,
  Storefilters,
  StoresearchBy,
  ProductColumns,
  ProductsearchBy,
  Productfilters,
  ProductcanlenderFilter
} from "../../service/ReviewService.js";
import { reviewApi } from "../../apis/order.apis.js";
import { useFetchAll } from "../../custom/FetchApiHook.jsx";
import StarRating from "../../components/RatingStar.jsx";
import { useNavigate } from "react-router-dom";
import LoaderContext from "../../components/loader/LoaderContext.js";
import { toast } from "react-toastify";
import moment from "moment";
import Description from "../../components/Description/Description.jsx";

const ReviewComp = ({ reviewName, disabledFilters, pagination, handlePagination }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [selectedCellData, setSelectedCellData] = useState(null);
  const [replyModalVisible, setReplyModalVisible] = useState(false);
  const [currentReview, setCurrentReview] = useState(null);
  const [replyText, setReplyText] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalError, setModalError] = useState("");
  const { handleLoading } = useContext(LoaderContext)

  const debounceTimeout = useRef(null);
  const { value, fetchAllData } = useFetchAll(() => reviewName === "product_review" ? reviewApi.getAllProductReviews(pagination ? pagination : {}, search) : reviewApi.getAllVendorReviews(pagination ? pagination : {}, search));

  const columns = reviewName === "product_review" ? ProductColumns : StoreColumns;

  const handleCellClick = async (row, field = "") => {
    if (field === "product_detail") {
      navigate(`/store/product-details/${row.product_detail._id}`);
    } else if (field === "replyAction") {
      console.log(row)
      setCurrentReview(row);
      setReplyText(row.vendorReply || "");
      setReplyModalVisible(true);
      setModalError("");
    }
    // else if (field === "hideAction") {
    //   handleHideReview(row._id);
    // }
  };

  // const handleHideReview =  () => {
  //   toast.warning("Please contact with Admin")
  // };

  const handleGetSingleReview = async (reviewId) => {
    handleLoading(true)
    try{
      const res = await reviewApi.getSingleReview(reviewId)
      setReplyText(res.data?.data?.vendor_reply)
    }
    catch(err){
      console.log(err)
    }
    finally{
      handleLoading(false)
    }
  }

  useEffect(() => {
      if(currentReview){
        handleGetSingleReview(currentReview?._id)
      }
  }, [currentReview]);

  const handleSubmitReply = async () => {
    if (!replyText.trim()) {
      setModalError("Reply cannot be empty.");
      return;
    }
    try {
      setLoading(true);
      handleLoading(true)
      const reviewId = currentReview?._id

      const payload = {
        vendor_reply: replyText,
      };
      await reviewApi.vendorReply(payload, reviewId);
      toast.success("Reply added successfully")
      fetchAllData();
      setReplyModalVisible(false);
    } catch (error) {
    } finally {
      setLoading(false);
      handleLoading(false)
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1
      }
      handlePagination && handlePagination(data)
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback((s) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      handleSearch(s);
    }, 1500);
  }, [handleSearch]);

  const handleClearFilter = () => {
    const clearPagination = {
      "page": 1,
      "limit": 5,
      "sortOrder": "desc",
      "filter": {}
    }
    handlePagination && handlePagination({ clearPagination })
  }

  const handleFilter = (name, value) => {
    let data = {}
    if (name === 'search_by') {
      data.sortOrder = value.code
    }
    else {
      const filter = {}
      filter[name] = value.code ? value.code : value
      data.filter = filter
    }
    handlePagination && handlePagination(data)
  }

  useEffect(() => {
    fetchAllData()
  }, [pagination, search]);

  const DataFilter = reviewName === "product_review"
    ? Productfilters.filter((f) => disabledFilters ? !disabledFilters.includes(f.inputName) : true)
    : Storefilters.filter((f) => disabledFilters ? !disabledFilters.includes(f.inputName) : true);

  return (
    <div className="p-1 mr-6 mt-4">
      {replyModalVisible && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-y-auto">
          <div
            className="fixed inset-0 bg-gradient-to-br from-black/60 to-black/40 backdrop-blur-sm transition-opacity duration-300 ease-out"
            onClick={() => !loading && setReplyModalVisible(false)}
          />

          <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-2xl max-h-[calc(100vh-2rem)] overflow-hidden transform transition-all duration-300 ease-out animate-[fadeInUp_0.3s]">
            <div className="bg-primaryColor p-5 text-white">
              <div className="flex items-center justify-between">
                <h3 className="text-xl font-semibold">Reply to Review</h3>
                <button
                  className="p-1 pl-3 rounded-full hover:bg-white/20 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white/50"
                  onClick={() => setReplyModalVisible(false)}
                  disabled={loading}
                  aria-label="Close"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            <div className="p-6 overflow-y-auto max-h-[calc(100vh-10rem)]">
              {currentReview && (
                <div className="space-y-6">
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-100">
                    <div className="w-full flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                      <div className="flex items-center space-x-3">
                        <div>
                          <img src={currentReview?.user?.profile_image} alt={currentReview?.user?.first_name} className="h-16 w-16 rounded-full object-cover" />
                        </div>
                        <div>
                          <h4 className="text-base font-medium text-primaryColor">
                            {currentReview.user?.first_name || 'Anonymous'} {currentReview.user?.last_name}
                          </h4>
                          <div className="text-xs text-gray-500 mt-1">
                            {moment(currentReview.createdAt).format("DD-MM-YYYY")}
                          </div>
                        </div>
                      </div>
                      <StarRating stars={currentReview.rating} />
                    </div>
                    <div className="mt-2">
                      <Description description={currentReview.review} length={100} />
                    </div>
                  </div>

                  <div className="relative">
                    <label htmlFor="reply" className="block text-sm font-medium text-primaryColor mb-2">
                      Your Reply <span className="text-red500">*</span>
                    </label>
                    <textarea
                      id="reply"
                      rows={4}
                      value={replyText}
                      onChange={(e) => setReplyText(e.target.value)}
                      className="w-full text-primaryColor px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gren200 focus:border-transparent transition-all duration-200 resize-none disabled:bg-gray-50 placeholder-primaryColor"
                      placeholder="Write a thoughtful response..."
                      disabled={loading}
                    />
                    {modalError && (
                      <div className="mt-2 text-sm text-red500 flex items-start">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mt-0.5 mr-1 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {modalError}
                      </div>
                    )}
                  </div>


                  <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-2">
                    <button
                      className="px-5 py-2.5 rounded-lg border border-gray-300 text-primaryColor hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
                      onClick={() => setReplyModalVisible(false)}
                      disabled={loading}
                    >
                      Cancel
                    </button>
                    <button
                      className="px-5 py-2.5 rounded-lg bg-buttonColor text-white hover:opacity-90 focus:ring-2 focus:ring-primaryColor/50 focus:ring-offset-2 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-medium shadow-sm"
                      onClick={handleSubmitReply}
                      disabled={loading || !replyText?.trim()}
                    >
                      {loading ? (
                        <span className="flex items-center justify-center">
                          <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          Submitting...
                        </span>
                      ) : 'Post Reply'}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <Card data={value?.data?.ratingDistribution} title={reviewName === "product_review" ? "Product Rating" : "Store Rating"} />

      <BasicTable
        columns={columns}
        data={reviewName === "product_review" ? value.data?.ratingsReviews : value?.data?.ratingsReviews}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: value?.data?.page || 1,
          rows: value?.data?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: value.data?.totalPages || 1,
          totalCount: value.data?.totalCount || 1
        }}
        SearchBy={reviewName === "product_review" ? ProductsearchBy : StoresearchBy}
        handleSearch={debouncedSearch}
        handleFilter={(name, value) => handleFilter(name, value)}
        handleClearFilter={handleClearFilter}
        filters={DataFilter}
        WeekRange={false}
        MonthRange={true}
        canlenderFilter={reviewName === "product_review" ? ProductcanlenderFilter : StorecanlenderFilter}
        selectedData={selectedCellData}
        handleCellClick={handleCellClick}
      />
    </div>
  );
}

export default ReviewComp;

const Card = ({ data, title, ratingCount }) => {
  const { theme } = useSelector((state) => state.theme);
  return (
    <div
      className={`p-1 ml-4 mr-1 mb-4 rounded-lg shadow-[0px_0px_15px_0px_rgba(0,0,0,0.2)] ${theme === "light" ? "bg-secondaryColor" : "bg-darkThirsary"
        }`}
    >
      <div className="flex justify-between items-center">
        <span className={`text-lg ml-5 mt-5 ${theme === "light" ? "bg-secondaryColor text-primaryColor" : "bg-darkThirsary text-darkSecondary"
          }`}>
          {title}
        </span>
      </div>

      <div className="py-3">
        {data && data.map((d, i) => (
          <div key={i} className="flex justify-between px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors">
            <span className="flex items-center">
              <StarRating stars={d.rating} />
            </span>
            <span className="text-sm font-medium">
              {d.count} ({d.percentage}%)
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};